var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHexagon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 140,
    viewBox: "0 0 358 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_6901",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 359,
    height: 140
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00292969 5C0.00292969 2.23857 2.24151 0 5.00293 0H353.003C355.764 0 358.003 2.23858 358.003 5V135C358.003 137.761 355.764 140 353.003 140H5.00294C2.24151 140 0.00292969 137.761 0.00292969 135V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_6901)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M375.989 26.8963C377.698 26.6217 379.374 27.5433 380.048 29.1287L418.998 120.735C419.624 122.208 419.239 123.914 418.04 124.981L340.507 193.957C339.528 194.828 338.163 195.129 336.907 194.749L260.419 171.658C259.057 171.247 258.046 170.106 257.807 168.71L246.329 101.633C246.162 100.659 246.39 99.6579 246.963 98.8495L287.017 42.3329C287.601 41.5092 288.494 40.9542 289.493 40.7936L375.989 26.8963Z",
    fill: "#FF544F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.831 27.9453L405.181 70.2684L396.313 152.513L334.831 232.297L269.678 154.805L260.217 67.6049L334.831 27.9453Z",
    stroke: "#FF544F",
    strokeWidth: 2.81853,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.778 120C328.886 120 337.891 111.046 337.891 100C337.891 88.9543 328.886 80 317.778 80C306.671 80 297.666 88.9543 297.666 100C297.666 111.046 306.671 120 317.778 120Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.65 94.7031C316.287 94.7031 315.183 95.8969 315.183 97.3686V108.712C315.183 110.185 316.288 111.378 317.65 111.378C319.013 111.378 320.117 110.184 320.117 108.712V97.3686C320.117 95.8969 319.012 94.7031 317.65 94.7031Z",
    fill: "#FF544F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.65 93.3291C319.013 93.3291 320.117 92.1353 320.117 90.6635C320.117 89.191 319.012 87.998 317.65 87.998C316.288 87.998 315.183 89.1918 315.183 90.6635C315.183 92.1353 316.287 93.3291 317.65 93.3291Z",
    fill: "#FF544F"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHexagon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hexagon.ba175631d868e09c6e1e41306ca59b1e.svg";